import * as amplitude from '@amplitude/analytics-browser'
import { EventPrefix, Trigger } from '@pathccm/common-analytics/events'

import launchDarklyJsClient from './reporting/launchdarkly-js-client'
import { getReportingAdapter } from './reporting/get-reporting-adapter'
import { SegmentTransitionFlag } from '@pathccm/browser-analytics'

export const amplitudeAnalytics = (): void => {
  launchDarklyJsClient.on('ready', () => {
    // Capture Link Clicks
    window.addEventListener('click', (event: Event) => {
      let t

      if (event.target instanceof HTMLAnchorElement) {
        t = event.target
      } else if ((event.target as HTMLElement)?.parentElement instanceof HTMLAnchorElement) {
        if (event.target === null) return

        // Some instances we wrap buttons in a tags
        t = (event.target as HTMLElement).parentElement
      } else {
        return
      }

      const marketingSiteSegmentTransition = launchDarklyJsClient.variation('marketing-site-segment-transition', 'amplitude') as SegmentTransitionFlag
      const reporting = getReportingAdapter(marketingSiteSegmentTransition)

      const payload = {
        href: t.href,
        text: t.text,
        id: t.id,
        hash: t.hash,
        hostname: t.hostname,
        className: t.className
      }

      if (t.hostname !== window.location.hostname) {
        amplitude.setTransport('beacon')

        void reporting.trackLink(event, t.href, {
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.OUTBOUND_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.OUTBOUND_LINK_CLICKED
          }
        })

        amplitude.flush()
      } else if (t.hash !== undefined && t.hash !== '') {
        void reporting.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.ANCHOR_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.ANCHOR_LINK_CLICKED
          }
        })
      } else {
        void reporting.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.INTERNAL_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.INTERNAL_LINK_CLICKED
          }
        })
      }
    })

    window.addEventListener('pagehide', () => {
      amplitude.setTransport('beacon')
      amplitude.flush()
    })
  })
}
